export interface Product {
  id: string;
  name: string;
  tagline: string;
  description: string;
  highlights: string[];
  techPills: string[];
  gradient: string;
  iconPath: string;
  url: string;
}

export const products: Product[] = [
  {
    id: 'stackntrack',
    name: 'StackNTrack',
    tagline: 'Social Habit & Accountability Tracker',
    description: 'Build habits through gamification, AI coaching, and social accountability. Users create stacks of repeatable practices, join challenges, and track progress with an AI coach that analyzes patterns and provides personalized motivation.',
    highlights: [
      'AI-powered coaching that analyzes habit patterns and skip reasons',
      'Social accountability with shared stacks, challenges, and leaderboards',
      'Gamified experience with streaks, badges, and completion certificates',
    ],
    techPills: ['React Native', 'Expo', 'Supabase', 'OpenAI', 'Firebase'],
    gradient: 'from-emerald-500/20 to-teal-500/20',
    iconPath: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z',
    url: 'https://stackntrack.app',
  },
  {
    id: 'evolog',
    name: 'Evolog',
    tagline: 'AI Decision Intelligence Platform',
    description: 'Transform how you think, plan, and create. Evolog guides users through structured decision frameworks, automates research from Reddit and app stores, and generates polished deliverables like presentations and documents.',
    highlights: [
      'Dynamic AI-guided frameworks tailored to your specific goal',
      'Automated research pulling insights from Reddit, App Store, and more',
      'One-click generation of presentations, Instagram carousels, and documents',
    ],
    techPills: ['Next.js', 'Multi-LLM', 'Supabase', 'Stripe', 'Tavily'],
    gradient: 'from-blue-500/20 to-indigo-500/20',
    iconPath: 'M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z',
    url: 'https://evolog.ai',
  },
  {
    id: 'slidewithai',
    name: 'SlidewithAI',
    tagline: 'AI Presentation Builder',
    description: 'Create stunning presentations with AI assistance. 52+ layouts, intelligent content generation, real-time collaboration via MCP, and text-to-speech narration with synchronized captions — all in a modern canvas editor.',
    highlights: [
      '52+ professional layouts across presentations, Instagram, and posters',
      'Real-time AI editing through MCP server integration',
      'Presentation recording with TTS narration and karaoke-style captions',
    ],
    techPills: ['Next.js', 'Supabase', 'MCP', 'Google AI', 'Ably'],
    gradient: 'from-purple-500/20 to-pink-500/20',
    iconPath: 'M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01',
    url: 'https://slidewithai.com',
  },
];
